export default {
	listagem: {
		itens: [],
		totalItens: 0,
		totalPaginas: 0,
	},
}
